import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  teamName: string,
  fileID: string,
  fileName: string,
  filePath: string,
  contentType: string,
  size: number,
  displaySize: string,
  isPublic: bool,
  createdBy: string,
  MD5Hash: string,
  ETag: string,
  createdDate: string,
  previousVersion: string,
  nextVersion: string,
  originalFile: string,
  tags: arrayOf(string),
  color: string,
  uploadUrl: string,
  downloadUrl: string,
  isUploaded: bool,
  copyOf: string,
  processID: string,
  stepName: string,
  runID: string,
  taskName: string,
  threadID: string,
  messageID: string
});



// WEBPACK FOOTER //
// ./js/types/api/file.js